export const formatExpiryDate = (timestamp: number): string => {
	const date = new Date(timestamp);
	const datePart = date.toLocaleDateString('en-US', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	});
	const timePart = date.toLocaleTimeString('en-US', {
		hour: '2-digit',
		minute: '2-digit',
		hour12: true,
	});
	return `${datePart} at ${timePart}`;
};
